<template>
  <div>
    <div class="h4 mb-4">{{ $t('checkout.organizer') }}</div>
    <div class="grid grid-cols-2 gap-1">
      <div>{{ customer.alias }}</div>
      <div>{{ customer.address }}</div>
      <div>CVR: {{ customer.vat }}</div>
      <div>{{ customer.zip + ' ' + customer.city }}</div>
    </div>

    <div class="border-t border-surface-grey mt-10 pt-10">
      <div class="h4 mb-4">
        {{ $t('checkout.order_information') }}
      </div>
      <div class="grid grid-cols-2 gap-6">
        <div>
          <div class="text-sm text-text">
            {{ $t('checkout.order_number') }}:
          </div>
          <div>{{ cart.receiptOrder.orderid }}</div>
        </div>

        <div>
          <div class="text-sm text-text">{{ $t('checkout.order_time') }}:</div>
          <div>{{ formatDate(cart.receiptMessage.ts) }}</div>
        </div>

        <div v-if="cart.receiptMessage.transaction">
          <div class="text-sm text-text">
            {{ $t('checkout.transaction_id') }}:
          </div>
          <div>{{ cart.receiptMessage.transaction }}</div>
        </div>

        <div v-if="cart.receiptMessage.cardnumber">
          <div class="text-sm text-text">{{ $t('checkout.card_number') }}:</div>
          <div>{{ cart.receiptMessage.cardnumber.replace(/X/g, '*').replace(/(\*{4})/g, '**** ') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

  import { computed } from 'vue';

  import { useCartStore } from '@/stores/cart';
  import { useGeneralStore } from '@/stores/general';
  import type {  Customer} from '@/types';
  import { formatDate } from '@/utils/formatDate';

  const cart = useCartStore();
  const generalStore = useGeneralStore();

  const customer = computed(() => generalStore.customer() as Customer);

</script>
